import React from "react";
import { SelectBoxPresenter, PresenterProps } from "./SelectBox";

type SelectBoxProps = PresenterProps;

export const SelectBox: React.FC<SelectBoxProps> = (props) => {
  return <SelectBoxPresenter {...props}></SelectBoxPresenter>;
};
